// Import jQuery once
import $ from 'jquery';

// Expose the same instance globally
window.$ = window.jQuery = $;

require("./blog/plugins.js");
require("../vendors/broccoli/js/main.js");
import "../styles/blog/style.scss";

import { PromiseAjaxGet } from "./globals.js"
import { ReplaceAjax } from "./globals.js"


/* --------------------------------------------------------
    1. Functions
-------------------------------------------------------- */


function UpdateQueryParam(SearchParam_object) {

    const url = new URL(window.location);
    
    //console.log("SearchParam_object: ", SearchParam_object);
    
    for (const [key, value] of SearchParam_object) {
        //console.log(key, value)
        if (key === "selected_facets") {
            // Allow multiple instances
            url.searchParams.append(key, value);
            url.searchParams.delete("page");
        }
    
        if (key === "sort_by" || key === "q") {
            // Replace existing key/value pair or added if new
            url.searchParams.set(key, value);
            url.searchParams.delete("page");
        }
    
        if (key === "page") {
            url.searchParams.set(key, value);
        }
        
    }
    
    
    
    window.history.pushState({}, "", url);
}
    
function RemoveQueryParam(SearchParam_object) {
    
    const url = new URL(window.location);
    
    
    for (const [key, value] of SearchParam_object) {
    
        url.searchParams.delete(key, value);
    
    }
    
    window.history.pushState({}, "", url);
}

function HideScrollbarOptionsBar(handler) {

    for (let i = 0; i < handler.length; i++) {
        let horizontalScrollbarHeight = handler[i].offsetHeight - handler[i].clientHeight; 
        handler[i].style["padding-bottom"] = horizontalScrollbarHeight + "px";
    }
}


/* --------------------------------------------------------
    Remove Sticky Header
-------------------------------------------------------- */
jQuery(function () {
    $(".ltn__header-middle-area").removeClass("ltn__header-sticky");
})

/* --------------------------------------------------------
    Facets Calls 
-------------------------------------------------------- */
$("#content_inner").on('click', '.sidebar_filters a', function (ev) {
    // You are here if facet turns from unselected to selected
    ev.preventDefault();

    var filter_value = $(this).parent().attr('value');

    const urlParams = new URLSearchParams();
    urlParams.append("selected_facets", filter_value);

    UpdateQueryParam(urlParams);

    //  Substitute link with strong name
    $('.facet_checkbox[name="'+filter_value+'"]').nextAll('a').hide();
    $('.facet_checkbox[name="'+filter_value+'"]').nextAll('strong').show();

    // Tick Checkbox
    $('.facet_checkbox[name="'+filter_value+'"]').prop("checked", true);

    // Update Page
    PromiseAjaxGet("")
    .then(function($ajax_data){
        ReplaceAjax($ajax_data);
        })

})

$("#content_inner").on('change', '.facet_checkbox', function (ev) {
    
    // You are here if facet turns from unselected to selected
    ev.preventDefault();
    var filter_value = $(this).parent().attr('value');

    const urlParams = new URLSearchParams();
    urlParams.append("selected_facets", filter_value);

    if ($(this).is(":checked")) {

        // Update all checkbox status accross the DOM
        $('.facet_checkbox[name="'+filter_value+'"]').prop("checked", true);

        //  Substitute link with strong name
        $('.facet_checkbox[name="'+filter_value+'"]').nextAll('a').hide();
        $('.facet_checkbox[name="'+filter_value+'"]').nextAll('strong').show();

        UpdateQueryParam(urlParams);

    } else {

        // Update all checkbox status accross the DOM
        $('.facet_checkbox[name="'+filter_value+'"]').prop("checked", false);

        //  Substitute strong name with link
        $('.facet_checkbox[name="'+filter_value+'"]').nextAll('a').show();
        $('.facet_checkbox[name="'+filter_value+'"]').nextAll('strong').hide();

        RemoveQueryParam(urlParams);

    }

    // Update Page
    PromiseAjaxGet("")
        .then(function($ajax_data){
            ReplaceAjax($ajax_data);
            })

})

$("#content_inner").on('change', '#id_sort-by-form', function (ev) {
    ev.preventDefault();

    const urlParams = new URLSearchParams($('#id_sort-by-form').serialize());

    UpdateQueryParam(urlParams);
    PromiseAjaxGet("")
        .then(function($ajax_data){
            ReplaceAjax($ajax_data);
            })
})

/* --------------------------------------------------------
    Grid Scrollbar Option
-------------------------------------------------------- */
jQuery(function () {
    HideScrollbarOptionsBar(document.querySelectorAll('[id^=add_to_basket_form_]'));
    ResetPositionScrollbarOptionsBar(document.querySelectorAll('[id^=add_to_basket_form_]'));
})
